import { ReadTime } from "lib-core"

export default ReadTime
